import { render, staticRenderFns } from "./ReportSubDN.vue?vue&type=template&id=0f4c1a72&scoped=true&"
import script from "./ReportSubDN.vue?vue&type=script&lang=js&"
export * from "./ReportSubDN.vue?vue&type=script&lang=js&"
import style0 from "./ReportSubDN.vue?vue&type=style&index=0&id=0f4c1a72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c1a72",
  null
  
)

export default component.exports